import { render } from "./fileAttachmentInfo.vue?vue&type=template&id=101a4f07&scoped=true"
import script from "./fileAttachmentInfo.vue?vue&type=script&lang=js"
export * from "./fileAttachmentInfo.vue?vue&type=script&lang=js"

import "./fileAttachmentInfo.vue?vue&type=style&index=0&id=101a4f07&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-101a4f07"]])

export default __exports__